<template>
    <div class="contract-manage-iflow-table">
        <table-box v-loading="subTabTable.tableLoading" :selection="TABLECONFIG.selection"
            :columns="TABLECONFIG.columns" :height="tableHeight" :actions="TABLECONFIG.actions"
            :rows="subTabTable.totalData"  @row-dblclick="dbClick">
            <!-- <template v-slot:col-append="{ col, row }">
                <div v-if="col.prop === 'mipUrl'">
                    <span size="mini" type="text" class="mip-page-link no-wrap" :title="row.mipUrl"
                        @click="handleLink(row)">{{ row.mipUrl || '' }}</span>
                </div>
            </template> -->
        </table-box>
        <div class="footer">
            <lots-pagination @size-change='subTabTable.sizeChange' :current-page.sync='subTabTable.pageNo'
                @current-change='subTabTable.pageChange' size="small" layout='total, sizes, prev, pager, next, jumper'
                :total='subTabTable.pageTotal' />
        </div>
    </div>
</template>

<script>
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getChangeHistroyDataList, registrationChangeGetByIdApi } from '@mdm/api/contractManage/contractRegistration.js';
import { ref, watch, computed, reactive } from '@vue/composition-api';
import { tableConfig } from './config.js';
import tableBox from '@/components/lots/tableBox/Index';
export default {
    components: {
        lotsPagination, tableBox
    },
    emits: ['dbApplyChange'],
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailPageState: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            return: () => {}
        },
        tableHeight: {
            type: Number,
            default: 357
        },
        actions: { // 表格操作信息，不传默认为空
            type: Object,
            default() {
                return {
                    list: []
                };
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        // eslint-disable-next-line complexity
        const TABLECONFIG = computed(() => {
            return config;
        });
        class IflowTalbeClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.renewalId = props.detailData.id;
                condition.orderBy = 'create_time';
                condition.orderByType = 'desc';
                return condition;
            }
            afterGetList(res) {
                super.afterGetList(res);
            }
        };
        const subTabTable = new IflowTalbeClass({
            Api: {
                listApi: getChangeHistroyDataList
            }
        });
        const dbClick = row => {
            const params = {
                id: props.detailData.id,
                changeCode: row.renewalChangeCode
            };
            registrationChangeGetByIdApi(params).then(res => {
                if (res && +res.code === 0) {
                    // 这里跳转变更单页面, 即新增一个续签页面
                    setupContext.emit('db-apply-change', { ...res.data, changeCode: row.renewalChangeCode }, 'change', '续签登记变更');
                }
            });
        };
        const handleLink = (row) => {
            window.open(row.mipUrl, '_blank');
        };
        const dictData = ref({});
        watch(
            () => [props.activeName, props.detailData.contractCode],
            (newVal, oldVal) => {
                if (newVal[0] === 'applyChange') {
                    subTabTable.getList();
                } else if (!newVal[1]) {
                    subTabTable.totalData.value = [];
                    subTabTable.pageTotal.value = 0;
                }
            },
            { deep: true, immediate: true }
        );

        return {
            config,
            TABLECONFIG,
            dictData,
            subTabTable,
            handleLink,
            dbClick
        };
    }
};
</script>
<style lang='less'>
.contract-manage-iflow-table {
    // margin-top: 15px;
    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .mip-page-link {
        color: #4285f5;
        cursor: pointer;
        &.no-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>
